jQuery(function ($) {
    $(document).ready(function () {
        $('.login-account #register').on('click', function(){
            $('.login').fadeOut(5);
            $('.register').fadeIn(100);
            
            window.history.replaceState( {}, document.title, window.location.pathname + '?register' );
        });

        $('.login-account #login').on('click', function(){
            $('.register').fadeOut(5);
            $('.login').fadeIn(100);

            window.history.replaceState( {}, document.title, window.location.pathname );
        });
    });
});